import headerNavLinks from '@/data/headerNavLinks';
import siteMetadata from '@/data/siteMetadata';
import { useRouter } from 'next/router';
import React from 'react';
// @ts-expect-error TODO (kevinhou): SVG assets don't have types yet
import { ReactComponent as LogoSvg } from '../public/static/images/EF_Logo_and_Wordmark_Color.svg';
import Footer from './Footer';
import Link from './Link';
import MobileNav from './MobileNav';
import SectionContainer from './SectionContainer';

const LayoutWrapper: React.FC = ({ children }) => {
  const { route } = useRouter();

  const useHeaderMargin = route !== '/';

  return (
    <>
      <header
        className={`flex items-center justify-between bg-white py-3 shadow ${
          useHeaderMargin ? 'mb-4' : ''
        }`}
      >
        <div>
          <Link href="/" aria-label={siteMetadata.headerTitle}>
            <div className="flex items-center justify-between">
              <div className="mr-3 ml-6">
                <LogoSvg alt="Exafunction" height={50} />
              </div>
            </div>
          </Link>
        </div>
        <div className="mr-8 flex items-center text-base leading-5">
          <div className="hidden sm:block">
            {headerNavLinks.map((link) => (
              <Link
                key={link.title}
                {...(link.external
                  ? {
                      target: '_blank',
                      rel: 'noreferrer',
                    }
                  : {})}
                href={link.href}
                className={`p-2 text-primary-900 dark:text-gray-100 md:p-4 lg:p-6 ${
                  route === link.href ? 'font-black' : 'font-light'
                }`}
              >
                {link.title}
              </Link>
            ))}
          </div>

          {/* <ThemeSwitch /> */}
          <MobileNav />
        </div>
      </header>
      <SectionContainer>
        <div className="flex flex-col justify-between" style={{ flexGrow: 1 }}>
          <main className="mb-auto">{children}</main>
        </div>
        <Footer />
      </SectionContainer>
    </>
  );
};

export default LayoutWrapper;
